import { apiSlice } from './apiSlice';
import { ORDERS_URL } from '../constants.js';

export const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (order) => ({
        url: ORDERS_URL,
        method: 'POST',
        body: { ...order },
      }),
      invalidatesTags: ['Order'],
    }),
    getOrderDetails: builder.query({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}`,
        method: 'GET',
      }),
      providesTags: ['Order'],
      keepUnusedDataFor: 5,
    }),
    getMyOrders: builder.query({
      query: (pageNumber = 1) => ({
        url: `${ORDERS_URL}/mine`,
        params: {
          pageNumber,
        },
      }),
      providesTags: ['Order'],
      keepUnusedDataFor: 5,
    }),
    getOrders: builder.query({
      query: ({
        keyword,
        pageNumber,
        paymentStatus,
        paymentMethod,
        deliveryStatus,
        dateFrom,
        dateTo,
        sort,
      } = {}) => {
        const params = new URLSearchParams();

        if (keyword) {
          params.set('keyword', keyword);
        }

        if (pageNumber) {
          params.set('pageNumber', pageNumber);
        }

        if (paymentStatus) {
          params.set('paymentStatus', paymentStatus);
        }

        if (paymentMethod) {
          params.set('paymentMethod', paymentMethod);
        }

        if (deliveryStatus) {
          params.set('deliveryStatus', deliveryStatus);
        }

        if (dateFrom) {
          params.set('dateFrom', dateFrom);
        }

        if (dateTo) {
          params.set('dateTo', dateTo);
        }

        if (sort) {
          params.set('sort', sort);
        }

        return {
          url: ORDERS_URL,
          params,
        };
      },
      providesTags: ['Order'],
      keepUnusedDataFor: 5,
    }),
    payOrder: builder.mutation({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/pay`,
        method: 'PUT',
      }),
      invalidatesTags: ['Order'],
    }),
    deliverOrder: builder.mutation({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/deliver`,
        method: 'PUT',
      }),
      invalidatesTags: ['Order'],
      keepUnusedDataFor: 5,
    }),
    calculateOrderPricing: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/pricing`,
        method: 'POST',
        body: data,
      }),
    }),
    checkStock: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/checkStock`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useGetOrderDetailsQuery,
  useGetMyOrdersQuery,
  useGetOrdersQuery,
  usePayOrderMutation,
  useDeliverOrderMutation,
  useCalculateOrderPricingMutation,
  useCheckStockMutation,
} = ordersApiSlice;
